import { fetchWithToken } from "../api.js";

const baseUrl = process.env.REACT_APP_API_URL;

const throwApiError = async (response, fallbackMessage) => {
  let data = null;

  try {
    data = await response.json();
  } catch {
    // 응답 본문이 JSON이 아니면 기본 오류 메시지를 사용한다.
  }

  const apiError = new Error(data?.detail || fallbackMessage);
  apiError.status = response.status;
  apiError.data = data;
  throw apiError;
};

export const fetchBarExams = async () => {
  const response = await fetch(baseUrl + "bar-exam/exams/", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    await throwApiError(response, "Failed to fetch bar exams");
  }

  return await response.json();
};

export const fetchMyBarExamSubmission = async (examId) => {
  const response = await fetchWithToken(
    baseUrl + `bar-exam/exams/${examId}/my-submission/`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    await throwApiError(response, "Failed to fetch my bar exam submission");
  }

  return await response.json();
};

export const submitBarExamAnswers = async (submission, draftToken = null) => {
  const response = await fetchWithToken(baseUrl + "bar-exam/submissions/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(draftToken
        ? { "X-Bar-Exam-Draft-Token": draftToken }
        : {}),
    },
    body: JSON.stringify(submission),
  });

  if (!response.ok) {
    await throwApiError(response, "Failed to submit bar exam answers");
  }

  return await response.json();
};

const getDraftHeaders = (draftToken) => ({
  "Content-Type": "application/json",
  ...(draftToken ? { "X-Bar-Exam-Draft-Token": draftToken } : {}),
});

const requestDraft = (url, options, authenticated) =>
  authenticated ? fetchWithToken(url, options) : fetch(url, options);

export const fetchBarExamDraft = async (
  examId,
  { authenticated = false, draftToken = null } = {},
) => {
  const response = await requestDraft(
    baseUrl + `bar-exam/exams/${examId}/draft/`,
    {
      method: "GET",
      headers: getDraftHeaders(draftToken),
    },
    authenticated,
  );

  if (!response.ok) {
    await throwApiError(response, "Failed to fetch bar exam draft");
  }

  return await response.json();
};

export const saveBarExamDraft = async (
  examId,
  draft,
  { authenticated = false, draftToken = null } = {},
) => {
  const response = await requestDraft(
    baseUrl + `bar-exam/exams/${examId}/draft/`,
    {
      method: "PUT",
      headers: getDraftHeaders(draftToken),
      body: JSON.stringify(draft),
    },
    authenticated,
  );

  if (!response.ok) {
    await throwApiError(response, "Failed to save bar exam draft");
  }

  return await response.json();
};

export const updateBarExamSubmission = async (submissionId, payload) => {
  const response = await fetchWithToken(
    baseUrl + `bar-exam/submissions/${submissionId}/`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    },
  );

  if (!response.ok) {
    await throwApiError(response, "Failed to update bar exam submission");
  }

  return await response.json();
};

export const fetchBarExamStatistics = async (examId) => {
  const response = await fetch(
    baseUrl + `bar-exam/exams/${examId}/statistics/`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    await throwApiError(response, "Failed to fetch bar exam statistics");
  }

  return await response.json();
};
